import CustomizeInfo from "./customizeInfo";
import { config } from "../utils/config";
import { LineItemType } from "../enums/lineItemType";

export default class Subitem {

    id: string;
    name: string;
    type: string;
    quantity: number;
    unitPrice: number;
    totalPriceWithoutAnyCharges: number;
    customLineItems: any = [];;
    customizationType: string;
    customizationInfo: any;
    productSpecification: any;
    productAttributes: any;
    multiSelectData: any = {};
    totalDiscount: number;

    constructor(mainItem: any= {}, subitem: any = {}) {
        this.id = subitem.id ?? '';
        const nameValue = subitem?.name?.[config('locale')];
        this.name = typeof nameValue === 'string' ? nameValue.trim() : '';
        this.type = subitem.custom?.fields?.lineItemType.toLowerCase() ?? '';
        this.quantity = subitem.quantity ?? 0;
        this.unitPrice = subitem.price.value.centAmount ?? 0;
        this.totalPriceWithoutAnyCharges = mainItem.data.effectivePrice.originalPrice.subItems[this.id] ?? 0;
        this.customLineItems = subitem?.customLineItems ?? [];
        this.customizationType = subitem.custom.fields.customizationType
        this.customizationInfo = JSON.parse(subitem.custom.fields.customizationInfo ?? '{}')
        this.productSpecification = JSON.parse(subitem.custom.fields.productSpecification ?? '{}')
        this.productAttributes = new CustomizeInfo(this.productSpecification, this.customizationInfo, this.customizationType);
        this.totalDiscount = Number(mainItem.data.effectivePrice.discount?.subItemtotal ?? 0);
        this.getMultiSelectAttributes(this.productAttributes.userSelectionInfo)
    }

    private getMultiSelectAttributes(userSelectionInfo){
        userSelectionInfo.forEach((userSelection)=>{
            if (userSelection?.renderType === config('MULTI_SELECT_USER_INPUT') && userSelection?.attribute) {
                this.multiSelectData.value = userSelection.value;
                this.multiSelectData.isExist = true; 
                this.multiSelectData.editData = userSelection
                let editData = {};

                userSelection.attributeValues?.forEach((attrVal) =>{
                    if (attrVal.originalValue) {
                        editData[attrVal.originalValue] = {
                            qty: 0,
                            attributeValue: attrVal.value,
                            lineItemId: null,
                            originalAttributeValue: attrVal.originalValue
                        };
                    }
                })
                editData[userSelection.originalAttributeValue] = {
                    qty : this.quantity,
                    attributeValue : userSelection.value,
                    lineItemId : this.id,
                    originalAttributeValue : userSelection.originalAttributeValue,
                    isMainItem : (this.type).toLowerCase() === LineItemType.MAINITEM,
                    arrCustomLineItem : this.customLineItems
                }
                this.multiSelectData.editData.attributeValues = editData
            }
        })
    }
}   
